<p>{{ languageService.get('no_report_found') }}</p>

<dx-button
  stylingMode="contained"
  [text]="languageService.get('navigate_to_reports')"
  type="normal"
  (onClick)="navigateToReports()"
></dx-button>
